import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.327 4.26a1 1 0 0 1 1.413.067l7.489 8.238.024.026 6.484 7.133q.07.065.126.139l5.877 6.464a1 1 0 0 1-1.48 1.346l-5.909-6.5a5.36 5.36 0 0 0-7.048.313 1 1 0 1 1-1.381-1.447 7.36 7.36 0 0 1 5.56-2.022l-3.327-3.66a11.34 11.34 0 0 0-5.08 2.87 1 1 0 0 1-1.4-1.43 13.3 13.3 0 0 1 4.99-3.078l-2.87-3.157a17.2 17.2 0 0 0-4.954 3.424 1 1 0 1 1-1.407-1.422A19.2 19.2 0 0 1 7.39 8.017l-2.13-2.344a1 1 0 0 1 .066-1.413M28.158 12.985A17.2 17.2 0 0 0 16.003 8h-.004q-1.24-.002-2.468.177a1 1 0 1 1-.288-1.98A19 19 0 0 1 16 6a19.2 19.2 0 0 1 13.567 5.565 1 1 0 0 1-1.408 1.42M18.042 13.135a1 1 0 0 1 1.21-.73 13.2 13.2 0 0 1 6.074 3.394 1 1 0 1 1-1.402 1.427 11.2 11.2 0 0 0-5.152-2.88 1 1 0 0 1-.73-1.211"
    />
    <path
      fill="currentColor"
      d="M17.5 25a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
    />
  </svg>
);
const SvgIconWifiSlash = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconWifiSlash);
export default Memo;
